import React, { useEffect } from 'react';
import styles from '../styles/FeedbackModal.module.css';

/**
 * Feedback Modal Component
 * Opens Timebook.net feedback form in a new tab
 *
 * Props:
 * - isOpen: Whether the modal is open
 * - onClose: Callback when modal should close
 */
function FeedbackModal({ isOpen, onClose }) {
  // Close on escape key
  useEffect(() => {
    function handleEscape(e) {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    }

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  // Open feedback form in new tab
  const handleOpenFeedback = () => {
    window.open('https://sophia.timebook.net/web/inbox/product-team', '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Send Feedback</h2>
          <button onClick={onClose} className={styles.closeButton} aria-label="Close feedback">
            ×
          </button>
        </div>

        <div className={styles.feedbackContent}>
          <div className={styles.messageContainer}>
            <p className={styles.message}>We'd love to hear from you!</p>
            <p className={styles.submessage}>Share your thoughts, report bugs, or suggest features.</p>
            <button onClick={handleOpenFeedback} className={styles.openButton}>
              Open Feedback Form
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeedbackModal;
